// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1s9qK","label":"Section_label__1Iiuf","contentWrap":"Section_contentWrap__2AUEo","footer":"Section_footer__UlOCe","footerInner":"Section_footerInner__1IvRH"};